var map = {
	"./aia_group.png": 141,
	"./cuhk.png": 142,
	"./fcc/white.png": 143,
	"./goxip.png": 144,
	"./hrtest/burgundy.png": 145,
	"./hrtest/charcoal.png": 146,
	"./hrtest/white.png": 147,
	"./intercom.png": 148,
	"./intercom1.png": 149
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56;